const OrderDetailReservation = class {
  constructor({
    reservation,
    reserevation, // TODO 오타 서버에서 반영되면 삭제 필요
    reservationStatus,
    reserevationStatus, // TODO 오타 서버에서 반영되면 삭제 필요
    reservationDateFrom,
    reservationDateTo
  }) {
    this.reservation = reservation || reserevation // TODO 오타 서버에서 반영되면 삭제 필요
    this.reservationStatus = reservationStatus || reserevationStatus // TODO 오타 서버에서 반영되면 삭제 필요
    this.reservationDateFrom = reservationDateFrom // "yyyy-MM-dd HH:mm:ss"
    this.reservationDateTo = reservationDateTo // "yyyy-MM-dd HH:mm:ss"
  }
}

export default null

export const ofOrderDetailReservation = (params = {}) => new OrderDetailReservation(params)
